import { render, staticRenderFns } from "./EditorPreviewCard.vue?vue&type=template&id=45b64a82&scoped=true"
import script from "./EditorPreviewCard.vue?vue&type=script&lang=js"
export * from "./EditorPreviewCard.vue?vue&type=script&lang=js"
import style0 from "./EditorPreviewCard.vue?vue&type=style&index=0&id=45b64a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b64a82",
  null
  
)

export default component.exports